var _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgIconLike = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 15.4074,
    fill: "#97C7FF",
    stroke: "white",
    strokeWidth: 1.18519
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.4807 13.3718C25.4807 12.0898 24.3182 11.4509 23.1517 11.4509H18.0692C18.0692 11.4509 19.516 8.48305 19.6974 7.8565C19.8788 7.22994 20.1261 6.22004 19.3223 5.67181C18.5185 5.11945 17.5704 5.24724 16.7831 6.00982C16.7831 6.00982 13.1021 10.5111 11.1235 12.0198V23.8253H21.5482C22.7148 23.8253 24.2564 23.376 24.3966 21.8756C24.413 21.7066 24.4749 21.3232 24.0379 20.7297C25.2457 19.8682 25.4023 18.4337 24.5656 17.4568C25.4848 16.5664 25.4848 15.4163 25.0272 14.526C25.4807 14.1303 25.4807 13.3636 25.4807 13.3636V13.3718Z",
    stroke: "#234B7A",
    strokeWidth: 1.18519,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3031 10.6306H7.34345C6.88814 10.6306 6.51904 10.9997 6.51904 11.455V23.4708C6.51904 23.9261 6.88814 24.2952 7.34345 24.2952H10.3031C10.7584 24.2952 11.1275 23.9261 11.1275 23.4708V11.455C11.1275 10.9997 10.7584 10.6306 10.3031 10.6306Z",
    stroke: "#234B7A",
    strokeWidth: 1.18519,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconLike, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/iconLike.5042fdb1.svg";
export { ForwardRef as ReactComponent };